// src/components/DeepLinkHandler.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DeepLinkHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Handle deep link paths: /app/*, /study/*, /subject/*, etc.
    const deepLinkPaths = [
      '/app', '/study', '/subject', '/flashcards', '/folder', 
      '/question', '/session', '/leaderboard', '/league', 
      '/chat', '/premium', '/settings', '/daily-question',
      '/subjects', '/folders', '/leagues', '/achievements',
      '/activity-points', '/usage', '/study-timer'
    ];
    
    const isDeepLink = deepLinkPaths.some(path => location.pathname.startsWith(path));
    
    if (isDeepLink) {
      // Extract the deep link path
      let deepLinkPath = location.pathname;
      
      // Remove leading slash if present
      if (deepLinkPath.startsWith('/')) {
        deepLinkPath = deepLinkPath.substring(1);
      }
      
      // Preserve query parameters
      const queryString = location.search;
      const fullDeepLink = queryString 
        ? `hazirlan://${deepLinkPath}${queryString}`
        : `hazirlan://${deepLinkPath}`;
      
      const userAgent = navigator.userAgent;
      const isIOS = /iPhone|iPad|iPod/.test(userAgent);
      const isAndroid = /Android/.test(userAgent);
      
      if (isIOS) {
        // Try to open app
        window.location.href = fullDeepLink;
        
        // Fallback to App Store after delay
        setTimeout(() => {
          window.location.href = 'https://apps.apple.com/app/hazirlan/id6749094669';
        }, 2500);
      } else if (isAndroid) {
        // Android Intent URL
        const intentUrl = `intent://${deepLinkPath}${queryString}#Intent;scheme=hazirlan;package=com.mmucteba.hazirlan;end`;
        window.location.href = intentUrl;
        
        // Fallback to Play Store
        setTimeout(() => {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.mmucteba.hazirlan';
        }, 2500);
      } else {
        // Web fallback - show download page or redirect
        navigate('/download');
      }
    }
  }, [location, navigate]);

  return null;
};

export default DeepLinkHandler;

